// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__epMq3","breadcrumbs":"Breadcrumbs_breadcrumbs__4ua4D"};